interface PersonWithSunInsideSVGProps {
  color: string;
  style: React.CSSProperties;
}

const PersonWithSunInsideSVG = ({
  color,
  style,
}: PersonWithSunInsideSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="33"
    height="40"
    viewBox="0 0 33 40"
    fill="none"
  >
    <g clipPath="url(#clip0_3339_65460)">
      <path
        d="M25.4916 39.8101H13.2469C12.3745 39.8101 11.6689 39.1653 11.6689 38.3725V33.4336H7.7505C6.2863 33.4336 5.37213 33.1567 4.77658 32.5346C4.12414 31.8556 3.87378 30.7897 3.94206 28.969C4.00655 27.2506 3.9762 26.6892 3.90792 25.5702C3.89275 25.3312 3.87758 25.0657 3.86241 24.7622L2.12509 24.7281C1.38919 24.7091 0.778479 24.3677 0.444671 23.7912C0.110864 23.2184 0.110864 22.5128 0.437085 21.8945C2.20095 18.5754 2.94443 17.1833 3.36928 16.3753C3.71826 15.7153 3.8662 14.987 3.79792 14.2587C3.76757 13.9363 3.75999 13.6176 3.7524 13.3483C3.68412 9.54365 4.84107 6.31937 7.10565 4.01307C9.53334 1.55124 13.1938 0.189453 17.412 0.189453C28.5869 0.189453 32.5699 7.29804 32.5699 13.9552C32.5699 16.7395 31.7391 19.4213 30.1687 21.7087C28.1355 24.6712 27.062 28.1989 27.062 31.9088V36.5745C27.0658 36.6124 27.0696 36.6503 27.0696 36.6883V38.3725C27.0696 39.1653 26.3603 39.8101 25.4916 39.8101ZM17.412 1.32743C13.5011 1.32743 10.1289 2.56783 7.91361 4.82483C5.84249 6.93768 4.8221 9.80159 4.88659 13.3407C4.89038 13.5873 4.89797 13.8794 4.92452 14.1676C5.01176 15.1122 4.81831 16.0643 4.36691 16.9178C3.94206 17.7219 3.20238 19.1179 1.43471 22.4408C1.29436 22.7063 1.29057 23.0022 1.42333 23.2298C1.5561 23.4574 1.81404 23.5901 2.14406 23.6015L4.40484 23.6432C4.70451 23.647 4.94728 23.886 4.96245 24.1857C4.98901 24.7243 5.01556 25.1492 5.03832 25.5133C5.1066 26.6665 5.14453 27.2468 5.07625 29.0221C5.01935 30.4825 5.17867 31.3246 5.59213 31.7532C5.95629 32.1326 6.62011 32.2995 7.74671 32.3033H12.2341C12.549 32.3033 12.8031 32.5574 12.8031 32.8722V38.3801C12.8031 38.5204 12.9852 38.6797 13.2432 38.6797H25.4878C25.7496 38.6797 25.9278 38.5204 25.9278 38.3801V36.7186C25.9278 36.7186 25.924 36.6807 25.924 36.6769C25.924 36.6579 25.924 36.639 25.924 36.62V31.9163C25.924 27.9751 27.0658 24.2274 29.228 21.0752C30.6694 18.9737 31.4281 16.5157 31.4281 13.9628C31.4281 6.17523 26.0568 1.33502 17.4082 1.33502L17.412 1.32743Z"
        fill={color}
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M17.6272 19.7211C14.7405 19.7211 12.3887 17.3731 12.3887 14.4826C12.3887 11.5922 14.7367 9.24414 17.6272 9.24414C20.5176 9.24414 22.8657 11.5922 22.8657 14.4826C22.8657 17.3731 20.5176 19.7211 17.6272 19.7211ZM17.6272 10.3859C15.3664 10.3859 13.5267 12.2256 13.5267 14.4864C13.5267 16.7472 15.3664 18.587 17.6272 18.587C19.888 18.587 21.7277 16.7472 21.7277 14.4864C21.7277 12.2256 19.888 10.3859 17.6272 10.3859Z"
        fill={color}
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M17.6276 7.92777C17.3127 7.92777 17.0586 7.67362 17.0586 7.35878V3.74379C17.0586 3.42895 17.3127 3.1748 17.6276 3.1748C17.9424 3.1748 18.1966 3.42895 18.1966 3.74379V7.35878C18.1966 7.67362 17.9424 7.92777 17.6276 7.92777Z"
        fill={color}
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M17.6276 25.7827C17.3127 25.7827 17.0586 25.5286 17.0586 25.2138V21.5988C17.0586 21.2839 17.3127 21.0298 17.6276 21.0298C17.9424 21.0298 18.1966 21.2839 18.1966 21.5988V25.2138C18.1966 25.5286 17.9424 25.7827 17.6276 25.7827Z"
        fill={color}
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M12.5934 10.0144C12.4493 10.0144 12.3013 9.95754 12.1913 9.84753L9.63465 7.29087C9.41085 7.06707 9.41085 6.70671 9.63465 6.4867C9.85845 6.2629 10.2188 6.2629 10.4388 6.4867L12.9955 9.04336C13.2193 9.26716 13.2193 9.62752 12.9955 9.84753C12.8855 9.95754 12.7375 10.0144 12.5934 10.0144Z"
        fill={color}
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M25.2184 22.638C25.0743 22.638 24.9263 22.5811 24.8163 22.4711L22.2596 19.9144C22.0358 19.6906 22.0358 19.3302 22.2596 19.1102C22.4835 18.8864 22.8438 18.8864 23.0638 19.1102L25.6205 21.6669C25.8443 21.8907 25.8443 22.2511 25.6205 22.4711C25.5105 22.5811 25.3625 22.638 25.2184 22.638Z"
        fill={color}
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M10.5082 15.0476H6.89321C6.57837 15.0476 6.32422 14.7935 6.32422 14.4787C6.32422 14.1638 6.57837 13.9097 6.89321 13.9097H10.5082C10.823 13.9097 11.0772 14.1638 11.0772 14.4787C11.0772 14.7935 10.823 15.0476 10.5082 15.0476Z"
        fill={color}
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M28.3637 15.0481H24.7487C24.4338 15.0481 24.1797 14.794 24.1797 14.4791C24.1797 14.1643 24.4338 13.9102 24.7487 13.9102H28.3637C28.6785 13.9102 28.9326 14.1643 28.9326 14.4791C28.9326 14.794 28.6785 15.0481 28.3637 15.0481Z"
        fill={color}
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M10.0367 22.638C9.89259 22.638 9.74465 22.5811 9.63465 22.4711C9.41085 22.2473 9.41085 21.8869 9.63465 21.6669L12.1913 19.1102C12.4151 18.8864 12.7755 18.8864 12.9955 19.1102C13.2193 19.334 13.2193 19.6944 12.9955 19.9144L10.4388 22.4711C10.3288 22.5811 10.1809 22.638 10.0367 22.638Z"
        fill={color}
        stroke={color}
        strokeMiterlimit="10"
      />
      <path
        d="M22.6656 10.0144C22.5215 10.0144 22.3736 9.95754 22.2636 9.84753C22.0398 9.62373 22.0398 9.26337 22.2636 9.04336L24.8202 6.4867C25.044 6.2629 25.4044 6.2629 25.6244 6.4867C25.8482 6.7105 25.8482 7.07086 25.6244 7.29087L23.0677 9.84753C22.9577 9.95754 22.8098 10.0144 22.6656 10.0144Z"
        fill={color}
        stroke={color}
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_3339_65460">
        <rect width="32.7587" height="40" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default PersonWithSunInsideSVG;
